import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NotificationsService, NotificationType } from 'angular2-notifications';
import { Router } from '@angular/router';
import { LoaderService  } from './loader.service';
import { DatePipe } from '@angular/common'
import { NgZone } from '@angular/core';

declare const $: any;
declare var require:any;
const httpOptions = {
        'responseType'  : 'arraybuffer' as 'json'
};

@Injectable({
  providedIn: 'root'
})
export class MasterService {

  previousUrl: string;
    
    currentUrl: string;

    roleName : string ;

    PNF = require('google-libphonenumber').PhoneNumberFormat;
    phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

  constructor(  private ngZone: NgZone, public loaderService: LoaderService, public datepipe: DatePipe, private http:HttpClient,private notifications:NotificationsService, private router: Router) { }

  public goToDashboard(){
    if(this.checkFeatureBoolean('DASHBOARD.DASHBOARD.LIST')){
        this.router.navigateByUrl('/dashboard/sales');
    }else if(this.checkFeatureBoolean('DASHBOARD.DASHBOARD.CREATE')){
    this.router.navigateByUrl('/dashboard/purchase');
    }else{
        this.router.navigateByUrl('/dashboard/sales');
    }
}
public goToBack(url:string){
    if(this.previousUrl!=null){
        this.router.navigateByUrl(this.previousUrl);
    }else{
        this.router.navigateByUrl(url);
    }
}
public dateFormat:any = "dd-MM-yyyy";

public dateTimeFormat:any = "dd-MM-yyyy HH:mm";

   
public slNo(page: number, size: number, index: number){
  return (page * size) + index + 1
}
public showLoader(){
 
  this.loaderService.showPreLoader();

} 
public hideLoader(){
 
  this.loaderService.hidePreLoader();

}
public tsdateFormat(date:any){
 return this.datepipe.transform(date, this.dateFormat)
}
public tsdateTimeFormat(date:any){
  return this.datepipe.transform(date, this.dateTimeFormat)
}

public getCallingCode(country:any){
  try{
      if(country==null || country.id==null || country.countryCode==null ){
          return null;
      }
      let obj;
      obj = this.phoneUtil.parseAndKeepRawInput('656565656',country.countryCode).getCountryCode();
      if(obj==null || obj==""){
          return null;
      }else{
          return obj;
      }
     } catch (error) {
           console.error(error);
           return null;
     }     
} 

public checkFeature(keyName: string, navigateUrl: string , bypassFeatureCheck = false){
  console.log("Check Feature : keyName " , keyName);
  console.log("Check Feature : url " , navigateUrl);
  
  let tmpuser = JSON.parse(localStorage.getItem('user') ??  'null') ;
  console.log("tmpuser " , tmpuser);

  
  if(tmpuser==null || tmpuser.featureMap==null){
      return false;
  }
  
  if(( tmpuser.featureMap[keyName]!=null && tmpuser.featureMap[keyName]) || bypassFeatureCheck ){
      console.log("Navigating to url :  " , navigateUrl);
      this.router.navigateByUrl(navigateUrl).then(success => {
        if (success) {
          console.log('Navigation successful');
        } else {
          console.log('Navigation failed');
        }
      }).catch(err => console.error('Navigation error:', err));
      
      return true;
  }else{
     // this.notifications.error('Unauthorized', "You do not have privilege to access", NotificationType.Error , 'yes');


     this.ngZone.run(() => {
      this.notifications.error('Error', 'You do not have privilege to access');
    });

      return false
  }
  
}

public checkFeatureWithParams(keyName: string, navigateUrl: string, data : any){
  
  let tmpuser = JSON.parse(localStorage.getItem('user') ??  'null' ) ;
  
  if(tmpuser==null || tmpuser.featureMap==null){
      return false;
  }
 
  if(tmpuser.featureMap[keyName]!=null && tmpuser.featureMap[keyName]){
      this.router.navigateByUrl(navigateUrl,  data);
      return true;
  }else{
    this.ngZone.run(() => {
      this.notifications.error('Error', 'You do not have privilege to access');
    });

      //this.notifications.create('Unauthorized', "You do not have privilege to access", NotificationType.Error , 'yes');
      return false
  }
  
}
public checkFeatureFound(keyName: string){
  
  let tmpuser = JSON.parse(localStorage.getItem('user') ??  'null' ) ;
  console.log("checkfeature  : tmpuser " , tmpuser );
  console.log("checkfeature  : keyName " , keyName );
  
  if(tmpuser==null || tmpuser.featureMap==null){
      return false;
  }
  console.log("tmpuser.featureMap[keyName] ", tmpuser.featureMap[keyName] );
  
  if(tmpuser.featureMap[keyName] !=null && tmpuser.featureMap[keyName] !=undefined && tmpuser.featureMap[keyName] == true ){
      return true;
  }else{
      //this.notifications.create('Unauthorized', "You do not have privilege to access", NotificationType.Error, 'yes');
      this.ngZone.run(() => {
        this.notifications.error('Error', 'You do not have privilege to access');
      });

      return false ;
  }
  
}

public checkFeatureBoolean(keyName: string){
  
  let tmpuser = JSON.parse(localStorage.getItem('user') ??  'null') ;
  
  if(tmpuser==null || tmpuser.featureMap==null){
      return false;
  }
  
  if(tmpuser.featureMap[keyName]!=null && tmpuser.featureMap[keyName]){
      return true;
  }else{
      return false
  }
  
}


public menuChecking(keyName: string){
  console.log("menuchecking for " , keyName);
  let tmpuser = JSON.parse(localStorage.getItem('user') ??  'null' ) ;
  let keys;
  
  if(tmpuser==null || tmpuser.featureMap==null){
      return false;
  }
 console.log("menuchecking tmpuser" , tmpuser);
  keys = Object.keys(tmpuser.featureMap);
  for(let i =0 ;i<keys.length;i++){
      if(keys[i].startsWith(keyName)){
        console.log("menuchecking return " , true);
          return true;
      }
  }
  console.log("menuchecking return " , false);
  return false;
  
}

public itemFocus(index: number, elementId: string){
  
  setTimeout(() => {
    const targetElem = document.getElementById(elementId + (index == null ? '' : index)) as HTMLElement | null;
    
    if (targetElem) {
      targetElem.focus();
    }
  }, 300);
  
}

public b64toBlob(b64Data : any, contentType : any , sliceSize : any) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {type: contentType});
  return blob;
}


public percentageFormat (percentage: any){
  if(percentage===undefined || percentage===null || percentage==='')
      return null;
  return percentage.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })

}

public currencyFormat (amount: any, currency: any){
  if(amount===undefined || amount===null || amount==='')
      return null;
  
  if(currency == undefined || currency == null || currency == "") 
      return null;
  
  if(currency.country ==undefined || currency.country ==null || currency.decimalPlace == undefined 
          || currency.decimalPlace ==null || currency.country.locale==undefined ){
      
      return amount;
  }
  let locl = currency.country.locale.replace("_", "-");
  return amount.toLocaleString(locl, { minimumFractionDigits: currency.decimalPlace, maximumFractionDigits: currency.decimalPlace })

}



}
